import { Line, mixins } from 'vue-chartjs'

const { reactiveProp } = mixins

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: {
    'chartData': {
      type: Object,
      default: {}
    },

    'options': {
      type: Object,
      default: {
        responsive: true,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            gridLines: {
              display: false
            }
          }]
        }
      }
    },
    chartId: {
      type: String,
      default: 'line-chart'
    },
    chartClass: {
      type: String,
      default: ''
    }
  },
  mounted() {
    this.$refs.canvas.className = this.chartClass
    this.renderChart(this.chartData, this.options)
  }
}

